/*
|--------------------------------------------------------------------------
| Mutation Types
|--------------------------------------------------------------------------
*/
export const SET_USER = 'SET_USER';
export const UNSET_USER = 'UNSET_USER';
export const UPDATE_USER_BALANCE = 'UPDATE_USER_BALANCE';
export const UPDATE_INVESTOR_PREMIUM_UPGRADE = 'UPDATE_INVESTOR_PREMIUM_UPGRADE';
export const UPDATE_INVESTOR_INVESTED_AMOUNT = 'UPDATE_INVESTOR_INVESTED_AMOUNT';
export const UPDATE_REFERRAL_LINK = 'UPDATE_REFERRAL_LINK';
export const UPDATE_REFERRAL_TASKS = 'UPDATE_REFERRAL_TASKS';

/*
|--------------------------------------------------------------------------
| Initial State
|--------------------------------------------------------------------------
*/
const initialState = {
    id: null,
	email: null,
	type: null,
	first_name: null,
	last_name: null,
	account_status: null,
	account_created_year: null,
	account_created_month: null,
	account_periods: null,
	role: null,
	company_name: null,
	application_status: false,
	application_id: null,
	bank_name: null,
	bank_account_no: null,
	balance: null,
	first_topup: null,
	verified_name: null,
	inv_plan_type: null,
	inv_invested_amount: null,
	premium_upgrade_requested_at: null,
	inactive_msg_formatted: null,
	inv_no: null,
	completed_application: null,
	has_note_application: false,
	company_number: null,
	auto_invest_exhausted_balance: false,
	auto_invest_issuer_exposure: false,
	auto_invest_issuer_exposure_percent: null,
	auto_invest_guaranteed_notes_option: false,
	check_if_has_auto_invest_bots: null,
	check_if_enabled_two_factor: null,
	check_if_hide_auto_invest_message: null,
	referral_link: null,
	referral_tasks: [],
	has_parent: false,
	has_mandate: false,
	check_if_agrees_agreement_update: false,
	eligible_guaranteed_notes_option_only: false,
	check_if_employment_updated: false,
	check_issuer_has_active_mandate: false,
	is_inv_fund_managed: false,
};

/*
|--------------------------------------------------------------------------
| Mutations
|--------------------------------------------------------------------------
*/
const mutations = {
	[SET_USER](state, payload) {
		state.email = payload.user.email;
		state.type = payload.user.type;
		state.first_name = payload.user.first_name;
        state.last_name = payload.user.last_name;
        state.account_status = payload.user.account_status;
        state.account_created_year = payload.user.account_created_year;
        state.account_created_month = payload.user.account_created_month;
        state.account_periods = payload.user.account_periods;
		state.role = payload.user.role;
		state.company_name = payload.user.company_name;
		state.application_status = payload.user.application_status;
		state.application_id = payload.user.application_id;
		state.bank_name = payload.user.bank_name;
		state.bank_account_no = payload.user.bank_account_no;
		state.balance = payload.user.balance;
		state.first_topup = payload.user.first_topup;
		state.verified_name = payload.user.verified_name;
		state.inv_plan_type = payload.user.inv_plan_type;
		state.inv_invested_amount = payload.user.inv_invested_amount;
		state.premium_upgrade_requested_at = payload.user.premium_upgrade_requested_at;
		state.inv_no = payload.user.inv_no;
		state.inactive_msg_formatted = payload.user.inactive_msg_formatted;
		state.completed_application = payload.user.completed_application;
		state.has_note_application = payload.user.has_note_application;
		state.company_number = payload.user.company_number;
		state.auto_invest_exhausted_balance = payload.user.auto_invest_exhausted_balance;
		state.auto_invest_issuer_exposure = payload.user.auto_invest_issuer_exposure;
		state.auto_invest_issuer_exposure_percent = payload.user.auto_invest_issuer_exposure_percent;
		state.auto_invest_guaranteed_notes_option = payload.user.auto_invest_guaranteed_notes_option;
		state.check_if_has_auto_invest_bots = payload.user.check_if_has_auto_invest_bots;
		state.check_if_enabled_two_factor = payload.user.check_if_enabled_two_factor;
		state.check_if_hide_auto_invest_message = payload.user.check_if_hide_auto_invest_message;
		state.referral_link = payload.user.referral_link;
		state.referral_tasks = payload.user.referral_tasks;
		state.has_parent = payload.user.has_parent;
		state.has_mandate = payload.user.has_mandate;
		state.check_if_agrees_agreement_update = payload.user.check_if_agrees_agreement_update;
		state.eligible_guaranteed_notes_option_only = payload.user.eligible_guaranteed_notes_option_only;
		state.check_if_employment_updated = payload.user.check_if_employment_updated;
		state.check_issuer_has_active_mandate = payload.user.check_issuer_has_active_mandate;
		state.is_inv_fund_managed = payload.user.is_inv_fund_managed;
	},

	[UNSET_USER](state, payload) {
		state.email = null;
		state.type = null;
		state.first_name = null;
        state.last_name = null;
		state.account_status = null;
		state.account_created_year = null;
		state.account_created_month = null;
		state.account_periods = null;
        state.role = null;
		state.name = null;
		state.company_name = null;
		state.application_status = null;
		state.application_id = null;
		state.bank_name = null;
		state.bank_account_no = null;
		state.balance = null;
		state.first_topup = null;
		state.verified_name = null;
		state.inv_plan_type = null;
		state.inv_invested_amount = null;
		state.premium_upgrade_requested_at = null;
		state.inv_no = null;
		state.inactive_msg_formatted = null;
		state.completed_application = null;
		state.has_note_application = false;
		state.company_number = null;
		state.check_if_has_auto_invest_bots = null;
		state.check_if_enabled_two_factor = null;
		state.check_if_hide_auto_invest_message = null;
		state.referral_link = null;
		state.referral_tasks = [];
		state.has_parent = false;
		state.has_mandate = false;
		state.check_if_agrees_agreement_update = false;
		state.auto_invest_guaranteed_notes_option = false;
		state.eligible_guaranteed_notes_option_only = false;
		state.check_if_employment_updated = false;
		state.check_issuer_has_active_mandate = false;
		state.is_inv_fund_managed = false;
	},

	[UPDATE_USER_BALANCE](state, payload) {
		state.balance = payload;
	},

	[UPDATE_INVESTOR_PREMIUM_UPGRADE](state, payload) {
		state.premium_upgrade_requested_at = payload;
	},
	[UPDATE_INVESTOR_INVESTED_AMOUNT](state, payload) {
		state.inv_invested_amount = parseFloat(state.inv_invested_amount)
		state.inv_invested_amount += parseFloat(payload);
	},
	[UPDATE_REFERRAL_LINK](state, payload) {
		state.referral_link = payload;
	},
	[UPDATE_REFERRAL_TASKS](state, payload) {
		state.referral_tasks = payload;
	}
};

/*
|--------------------------------------------------------------------------
| Actions
|--------------------------------------------------------------------------
*/
const actions = {
	setAuthUser: (context, user) => {
		context.commit(SET_USER, {user})
	},
	unsetAuthUser: (context) => {
		context.commit(UNSET_USER);
	},
	updateUserBalance: (context, balance) => {
		context.commit(UPDATE_USER_BALANCE, balance)
	},
	updateInvestorPremiumUpgrade: (context, datetime) => {
		context.commit(UPDATE_INVESTOR_PREMIUM_UPGRADE, datetime)
	},
	updateInvestorInvestedAmount: (context, amount) => {
		context.commit(UPDATE_INVESTOR_INVESTED_AMOUNT, amount)
	},
	updateReferralLink: (context, link) => {
		context.commit(UPDATE_REFERRAL_LINK, link)
	},
	updateReferralTasks: (context, tasks) => {
		context.commit(UPDATE_REFERRAL_TASKS, tasks)
	}
};

/*
|--------------------------------------------------------------------------
| Getters
|--------------------------------------------------------------------------z
*/
const getters = {
	isLoggedIn: (state) => {
		return !!(state.name && state.email);
	},

	isApplicationApproved: (state) => {
		return (state.application_status === 'Approved');
	},

	isInvestorDoneFirstUp: (state) => { // done first top up will always have a timestamp here
		return (state.first_topup)
	},

	getUser: (state) => {
		return state;
	},

	getPremiumUpgradeCreated: (state) => {
		return state.premium_upgrade_requested_at
	},
};

/*
|--------------------------------------------------------------------------
| Export the module
|--------------------------------------------------------------------------
*/
export default {
	state: initialState,
	mutations,
	actions,
	getters
}
